(function() {
    'use strict';

    angular
        .module('app.classes.sceneAugmenter', [])
        .service("sceneAugmenterService", ['API', '$timeout', 'f_User',
            function(API, $timeout, f_User) {
                function augmentScenes(scenesArr) {
                    const userLevel = f_User.getUserLevel();

                    scenesArr.forEach(function(scene) {
                        assignRights(scene, userLevel);
                        scene.$execute = $execute.bind(scene);
                        scene.$updateSceneSettings = $updateSceneSettings.bind(scene);
                        scene.$enableDisable = $enableDisable.bind(scene);
                    });
                }

                function assignRights(scene, userLevel) {
                    if (!scene.$UI) {
                        scene.$UI = {};
                    }
                    scene.$UI.canView = (scene.UserLevelRead >= userLevel ? true : false);
                    scene.$UI.canWrite = (scene.UserLevelWrite > userLevel ? false : true);
                }

                function $execute() {
                    const self = this;
                    const api = new API();
                    const params = { SceneId: this.SceneId };
                    return api.Scene.ExecuteScene(params).$promise
                    .then(function() {
                        self.$UI.ConditionIsTrue = true;
                        self.$UI.ActionIsRunning = true;
                        self.$UI.kickedOff = true;
                        $timeout(function () {
                            self.$UI.kickedOff = false;
                        }, 2000);
                    });
                }

                function $updateSceneSettings() {
                    const api = new API();
                    const params = {
                        Settings: [{
                            SceneId: this.SceneId,
                            DisplayName: this.DisplayName,
                            Enabled: this.Enabled,
                            Priority: this.Priority
                        }]
                    };
                    return api.Scene.UpdateSceneSettings(params).$promise;
                }

                function $enableDisable() {
                    this.Enabled = !this.Enabled;
                    return $updateSceneSettings.call(this);
                }

                return {
                    augmentScenes: augmentScenes
                };
            }
        ]);

})();
